var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_1684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C5.5957 0.5 0 6.0957 0 13C0 19.9043 5.5957 25.5 12.5 25.5C19.4043 25.5 25 19.9043 25 13C25 6.0957 19.4043 0.5 12.5 0.5ZM12.5 6.75C13.3628 6.75 14.0625 7.44971 14.0625 8.3125C14.0625 9.17529 13.3628 9.875 12.5 9.875C11.6372 9.875 10.9375 9.17676 10.9375 8.3125C10.9375 7.44824 11.6357 6.75 12.5 6.75ZM14.4531 19.25H10.5469C9.90234 19.25 9.375 18.7275 9.375 18.0781C9.375 17.4287 9.8999 16.9062 10.5469 16.9062H11.3281V13.7812H10.9375C10.2905 13.7812 9.76562 13.2563 9.76562 12.6094C9.76562 11.9624 10.293 11.4375 10.9375 11.4375H12.5C13.147 11.4375 13.6719 11.9624 13.6719 12.6094V16.9062H14.4531C15.1001 16.9062 15.625 17.4312 15.625 18.0781C15.625 18.7251 15.1025 19.25 14.4531 19.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_1684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.072cf97a5a7ce8ffb34b89ff86d0e64b.svg";
export { ForwardRef as ReactComponent };